import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import { gettext } from '@eb/i18n';

import {
    withFollowList,
    FollowList,
    addFollow,
} from '@eb/follow-organizer-ebui';

import './organizerFollowBucket.scss';

const listStyle = 'grid';
const size = 'mini';
const EnhancedFollowList = withFollowList(FollowList);

export class OrganizerFollowBucket extends Component {
    static propTypes = {
        organizers: PropTypes.arrayOf(PropTypes.string),
        userId: PropTypes.string,
        gaCategory: PropTypes.string,
        gaActionSuffix: PropTypes.string,
        isAuthenticated: PropTypes.bool,
        trackGAEvent: PropTypes.func,
        isGDPRCountry: PropTypes.bool,
    };

    state = {
        isListEmpty: false,
    };

    shouldComponentUpdate(nextProps, nextState) {
        const setEmptyState = nextState.isListEmpty !== this.state.isListEmpty;
        const newOrganizers = !isEqual(
            nextProps.organizers,
            this.props.organizers,
        );

        const shouldUpdate = setEmptyState || newOrganizers;

        return shouldUpdate;
    }

    _handleEmptyList = () => {
        this.setState({ isListEmpty: true });
    };

    render() {
        const {
            organizers,
            userId,
            gaCategory,
            gaActionSuffix,
            isAuthenticated,
            trackGAEvent,
            gaSettings,
            isGDPRCountry,
        } = this.props;

        const { isListEmpty } = this.state;
        const hasNoOrganizers = !organizers || isEmpty(organizers);

        const shouldShowEmptyBucket = isListEmpty || hasNoOrganizers;

        if (shouldShowEmptyBucket) {
            return <div className="organizer-follow-bucket__follow-empty" />;
        }

        const EnhancedFollowListWithData = addFollow(EnhancedFollowList);

        return (
            <div
                className="
                        content-bucket
                        organizer-follow-bucket
                    "
            >
                <div className="eds-l-pad-hor-3">
                    <div
                        className="
                                bucket-header__title
                                eds-g-cell
                                eds-g-cell-9-12
                                "
                    >
                        <h2
                            className="
                                eds-text-hs
                                eds-text-color--grey-700
                            "
                        >
                            {gettext('Featured Organizers')}
                        </h2>
                        <p className="eds-text-bm eds-text-color--grey-600">
                            {gettext(
                                'Follow the organizers from these events and get notified when they create new ones.',
                            )}
                        </p>
                    </div>
                </div>
                <div className="organizer-follow-bucket__follow-container">
                    <EnhancedFollowListWithData
                        isGDPRCountry={isGDPRCountry}
                        style={listStyle}
                        size={size}
                        onEmpty={this._handleEmptyList}
                        isClosable={true}
                        isHiddenWhenFollowed={true}
                        shouldHideDefaultDataPoint={true}
                        organizers={organizers}
                        userId={userId}
                        gaCategory={gaCategory}
                        gaActionSuffix={gaActionSuffix}
                        isAuthenticated={isAuthenticated}
                        trackGAEvent={trackGAEvent}
                        gaSettings={gaSettings}
                    />
                </div>
            </div>
        );
    }
}

export default OrganizerFollowBucket;
